/* eslint-disable react/prop-types */
import { Spin as AntSpin } from 'antd';
import React from 'react';
import cn from 'classnames';
import classes from './Spin.module.scss';

const Spin = ({ className, container, ...other }) => {
  return (<div className={cn(classes.wrapper, {
    [classes.container]: container
  }, className)}><AntSpin {...other} /></div>);
}

export default Spin;